<template>
    <div class="w-full p-[16px]">
        <template v-if="!load">
            <button v-on:click="pushback" class="text-[12px] mb-[8px] pr-4 py-2 text-[#2b2b2b] font-light rounded-lg hover:bg-gray-100 flex items-center gap-x-[12px]">
                <ArrowLeft :size="16" strokeWidth="1.3"/>
                Retourner à la liste
            </button>
            <div class="mb-[16px]">
                <h2 class="text-[18px] text-[#2b2b2b] font-light">Détails collaborateur</h2>
            </div>
            <div class="p-[8px] mb-[16px] border rounded-xl flex gap-x-[12px]">
                <div class="rounded-xl min-h-[190px] w-[35%] bg-[#f7f8fa] p-[16px]">
                    <div class="flex items-start justify-between mb-[8px]">
                        <div class="size-[80px] border-4 text-white text-[22px] border-white rounded-full bg-[#3474f4] flex items-center justify-center">
                            <span>{{ user.first_name.trim()[0] }}</span>
                        </div>
                        <!-- <button class="h-[35px] font-light px-4 border rounded-xl flex items-center justify-center bg-white text-[#2b2b2b]">Voir rapport</button> -->
                    </div>
                    <span class="text-[#2b2b2b] font-extralight text-[16px]">{{ user.matricule }}</span>
                    <h3 class="text-[#2b2b2b] text-[20px] my-[8px]">{{ user.first_name + " " + user.last_name }}</h3>
                    <p class="text-[#2b2b2b] font-extralight">{{ user.profile[0].label }} ({{ user.profile[0].pivot.employee_status }})</p>
                </div>
                <div class="p-[16px] text-[#2b2b2b] font-light text-[17px]">
                    <div class="flex items-center gap-x-[16px] mb-[12px]">
                        <AtSign :size="18" strokeWidth="1.3"/> <span>{{ user.email }}</span>
                    </div>

                    <div class="flex items-center gap-x-[16px] mb-[12px]">
                        <Phone :size="18" strokeWidth="1.3"/> <span>{{ user.phone }}</span>
                    </div>

                    <div class="flex items-center gap-x-[16px] mb-[12px]">
                        <DoorOpen :size="18" strokeWidth="1.3"/> <span v-for="value in user.zones" :key="value.id">{{ value.label }}</span>
                    </div>

                    <div class="flex items-center gap-x-[16px] mb-[12px]">
                        <GitPullRequest :size="18" strokeWidth="1.3"/> <span>{{ user.exceptions }} Exceptions</span>
                    </div>

                    <div class="flex items-center gap-x-[16px] mb-[12px]">
                        <GitPullRequest :size="18" strokeWidth="1.3"/> <span>{{ user.requests }} Requêtes</span>
                    </div>
                </div>
            </div>
            <div class="bg-white rounded-lg mb-[16px] w-full">
                    <div class="flex items-center w-full gap-x-[12px] text-[#2b2b2b] font-light py-[12px] overflow-hidden">
                        <span v-if="!isExiting" v-bind:class="getActiveClass('Personnel')" v-on:click="selectBar('Personnel')">Personnel</span>
                        <span v-if="!isExiting" v-bind:class="getActiveClass('Document')" v-on:click="selectBar('Document')">Dossier personnel</span>
                        <span v-if="!isExiting" v-bind:class="getActiveClass('Expérience&qualification')" v-on:click="selectBar('Expérience&qualification')">Expérience & Qualification</span>
                        <span v-if="!isExiting" v-bind:class="getActiveClass('PrêtAvance')" v-on:click="selectBar('PrêtAvance')">Prêt & Avance</span>
                        <span v-if="!isExiting" v-bind:class="getActiveClass('Contrat actuel')" v-on:click="selectBar('Contrat actuel')">Contrat actuel</span>
                        <span v-if="!isExiting" v-bind:class="getActiveClass('Ajouter un contrat')" v-on:click="selectBar('Ajouter un contrat')">Ajouter un contrat</span>
                        <span v-bind:class="getActiveClass('Historique des contrats')" v-on:click="selectBar('Historique des contrats')">Historique des contrats</span>
                        <span v-if="!isExiting" v-bind:class="getActiveClass('Information banque')" v-on:click="selectBar('Information banque')">Information banque</span>
                        <span v-if="!isExiting" v-bind:class="getActiveClass('Permissions')" v-on:click="selectBar('Permissions')">Permissions</span>
                        <span v-if="!isExiting" v-bind:class="getActiveClass('Zone autorisé')" v-on:click="selectBar('Zone autorisé')">Zone autorisé</span>
                        <span v-if="!isExiting" v-bind:class="getActiveClass('Validateur')" v-on:click="selectBar('Validateur')">Validateur</span>
                        <span v-if="!isExiting" v-bind:class="getActiveClass('Exit')" v-on:click="selectBar('Exit')">Exit</span>
                    </div>
            </div>
            <div class="p-[16px] rounded-xl border text-[#2b2b2b]">
                <div class="w-full" v-if="getActiveTab('Personnel')">
                    <div class="flex items-center gap-x-[12px] mb-[16px]">
                        <SquareUserRound :size="18" strokeWidth="1.3"/> <span class="font-light">Information personnel</span>
                    </div>

                    <div class="w-full flex items-center justify-between">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="name" class="font-light" >Nom</label>
                            <input type="text" v-model="form.first_name" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="John">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="lastname" class="font-light" >Prenom</label>
                            <input type="text" placeholder="Doe" v-model="form.last_name" name="lastname" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col">
                            <label for="email" class="font-light" >Email<span class="text-[#f44545]">*</span></label>
                            <input type="email" placeholder="john@gmail.com" v-model="form.email" name="email" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                        <div class="w-[49%] flex flex-col">
                            <label for="birthday" class="font-light" >Date de naissance<span class="text-[#f44545]">*</span></label>
                            <input type="date" v-model="form.birthdate" name="birthday" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="serial" class="font-light" >Identifiant<span class="text-[#f44545]">*</span></label>
                            <input v-model="form.serial" type="text" name="serial" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="matricule" class="font-light" >Matricule<span class="text-[#f44545]">*</span></label>
                            <input v-model="form.matricule" type="text" name="matricule" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="shift" class="font-light" >Horaire<span class="text-[#f44545]">*</span></label>
                            <select v-model="form.shift" name="shift" id="shift" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                <option v-for="shift in shifts" :key="shift.id" :value="shift.symbol">{{ shift.label }} : {{ shift.hour_start }} - {{ shift.hour_end }}</option>
                            </select>
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="nb_children" class="font-light" >Nombre d'enfant<span class="text-[#f44545]">*</span></label>
                            <input v-model="form.children_nb" type="number" min="0" name="nb_children" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>

                    <div class="w-[49%] flex items-center justify-between mt-[8px]">
                        <label for="isRH" class="font-light" >Membre des RH</label>
                        <input type="checkbox" v-model="form.is_hr" name="isRH" class="size-[16px] rounded-md border static opacity-100" id="isRH">
                    </div>

                    <div class="w-full flex items-center justify-end mt-[8px]">
                        <button v-on:click="updateEmploye" :disabled="asSend" class="h-[35px] font-light px-4 bg-[#5357ec] text-white rounded-xl flex items-center justify-center">
                            <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                            <span v-if="!asSend">Modifier</span>
                        </button>
                    </div>
                </div>

                <div class="w-full" v-if="getActiveTab('Information banque')">
                    <div class="flex items-center gap-x-[12px] mb-[16px]">
                        <CreditCard :size="18" strokeWidth="1.3"/> <span class="font-light">Information banque</span>
                    </div>

                    <div class="w-full flex items-center justify-between">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="rib" class="font-light" >Rib</label>
                            <input v-model="form.rib" type="text" name="rib" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="swift" class="font-light" >Code SWIFT</label>
                            <input v-model="form.swift" type="text" name="swift" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="bank" class="font-light" >Banque</label>
                            <input v-model="form.bank" type="text" name="bank" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="cnps" class="font-light" >Numéro Cnps</label>
                            <input v-model="form.n_cnps" type="text" name="cnps" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-end mt-[8px]">
                        <button v-on:click="updateEmploye" :disabled="asSend" class="h-[35px] font-light px-4 bg-[#5357ec] text-white rounded-xl flex items-center justify-center">
                            <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                            <span v-if="!asSend">Modifier</span>
                        </button>
                    </div>

                </div>

                <div class="w-full" v-if="getActiveTab('Contrat actuel')">
                    <div class="flex items-center gap-x-[12px] mb-[16px]">
                        <FilePenLine :size="18" strokeWidth="1.3"/> <span class="font-light">Contrat actuel</span>
                    </div>

                    <div class="w-full flex items-center justify-between">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="local" class="font-light" >Local ou expatrié</label>
                            <select v-model="update_contrat.employee_status" name="local" id="local" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                <option value="LOCAL">LOCAL</option>
                                <option value="EXPATRIÉ">EXPATRIÉ</option>
                            </select>
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="Département" class="font-light" >Profil</label>
                            <select disabled v-model="update_contrat.profile_id" name="Département" id="Département" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                <option value="">Choisissez le profil</option>
                                <option v-for="value in profils" :key="value.id" :value="value.id">{{ value.label }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="logement" class="font-light" >Prime de logement</label>
                            <input type="number" min="0" v-model="update_contrat.prime_logement" name="logement" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="transport" class="font-light" >Prime de transport</label>
                            <input type="number" min="0" v-model="update_contrat.prime_tp" name="transport" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="respon" class="font-light" >Prime de responsabilité</label>
                            <input type="number" min="0" v-model="update_contrat.prime_respo" name="respon" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="spe" class="font-light" >Prime de spéciale</label>
                            <input type="number" min="0" v-model="update_contrat.prime_speciale" name="spe" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-end mt-[8px]">
                        <button v-on:click="updateContrat" :disabled="asSend3" class="h-[35px] font-light px-4 bg-[#5357ec] text-white rounded-xl flex items-center justify-center">
                            <Loader2 v-if="asSend3" class="animate-spin mx-auto"/>
                            <span v-if="!asSend3">Modifier contrat</span>
                        </button>
                    </div>
                </div>

                <div class="w-full" v-if="getActiveTab('Ajouter un contrat')">
                    <div class="flex items-center gap-x-[12px] mb-[16px]">
                        <FileUser :size="18" strokeWidth="1.3"/> <span class="font-light">Contrat actuel</span>
                    </div>

                    <div class="w-full flex items-center justify-between">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="local" class="font-light" >Local ou expatrié<span class="text-[#f44545]">*</span></label>
                            <select v-model="profildata.employee_status" name="local" id="local" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                <option value="LOCAL">LOCAL</option>
                                <option value="EXPATRIÉ">EXPATRIÉ</option>
                            </select>
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="Département" class="font-light" >Profil<span class="text-[#f44545]">*</span></label>
                            <select v-model="profildata.profile_id" name="Département" id="Département" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                <option value="">Choisissez le profil</option>
                                <option v-for="value in profils" :key="value.id" :value="value.id">{{ value.label }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="cont" class="font-light" >Type de contrat<span class="text-[#f44545]">*</span></label>
                                        <select v-model="profildata.contract_type" name="cont" id="cont" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                            <option value="STAGE">STAGE</option>
                                            <option value="CDD">CDD</option>
                                            <option value="CDI">CDI</option>
                                            <option value="CONSULTANT">CONSULTANT</option>
                                        </select>
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="Début" class="font-light" >Début<span class="text-[#f44545]">*</span></label>
                            <input type="date" placeholder="" v-model="profildata.start" name="Début" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>
                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="Fin" class="font-light" >Fin<span class="text-[#f44545]">*</span></label>
                            <input type="date" v-model="profildata.end" name="Fin" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="pro" class="font-light" >Poste<span class="text-[#f44545]">*</span></label>
                            <input type="text" placeholder="" v-model="profildata.job_name" name="pro" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>
                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="base_salary" class="font-light" >Salaire de base<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.salary" name="base_salary" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="SurSalaire" class="font-light" >SurSalaire<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.sursalaire" name="SurSalaire" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>
                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="transport" class="font-light" >Prime de transport<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.prime_tp" name="transport" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="logement" class="font-light" >Prime de logement<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.prime_logement" name="logement" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>
                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="respon" class="font-light" >Prime de responsabilité<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.prime_respo" name="respon" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="spe" class="font-light" >Prime de spéciale<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.prime_speciale" name="spe" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-end mt-[8px]">
                        <button type="submit" :disabled="asSend2" class="px-8 py-3 bg-[#5357ec] text-white rounded-md">
                            <Loader2 v-if="asSend2" class="animate-spin mx-auto"/>
                            <span v-if="!asSend2">Ajouter un contrat</span>
                        </button>
                    </div>
                    
                </div>

                <div class="w-full" v-if="getActiveTab('Historique des contrats')">
                    <div class="flex items-center gap-x-[12px] mb-[16px]">
                        <ChartNoAxesGantt :size="18" strokeWidth="1.3"/> <span class="font-light">Historique des contrats</span>
                    </div>

                    <contractStory v-for="(value,idx) in contrats" :key="value.id" :contrat="value" :islast="(contrats.length - 1) == idx"/>
                </div>

                <div class="w-full" v-if="getActiveTab('Document')">
                    <DocumentColab />
                </div>

                <div class="w-full" v-if="getActiveTab('Expérience&qualification')">
                    <ExperienceColab />
                </div>

                <div class="w-full" v-if="getActiveTab('PrêtAvance')">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-x-[12px] mb-[16px]">
                            <HandCoins :size="18" strokeWidth="1.3"/> <span class="font-light">Historique prêt et avance</span>
                        </div>
                    </div>
                    <div v-if="advances.length == 0" class="mt-4 h-[200px] w-full flex items-center justify-center">
                        <p class="font-extralight">Aucun prêt/avance trouvé</p>
                    </div>
                    <div v-else v-for="(value) in advances" :key="value.id" class="relative mb-[16px]">
                        <div :class="['absolute h-full w-[12.5px] left-0 top-0 border-r z-[-1] border-r-[#0c5ccf]',{'hidden':islast}]"/>
                            <div class="flex items-center gap-x-[16px]">
                                <div class="flex items-center border-[3px] border-white justify-center bg-[#0c5ccf] size-[25px] rounded-full">
                                    <Check color="#ffffff" :size="16" strokeWidth="1.5"/>
                                </div>
                                <div class="font-light flex items-center gap-x-[16px]">
                                    <span class="font-extralight"><span class="capitalize">{{ value.type }}</span> {{ formatDate(value.created_at.split('T')[0])}}</span>
                                    <span>---</span>
                                    <span>{{ value.amount }} Fcfa</span>
                                </div>
                        </div>
                    </div>
                </div>

                <div class="w-full" v-if="getActiveTab('Permissions')">
                    <div class="flex items-center gap-x-[12px] mb-[16px]">
                        <FolderLock :size="18" strokeWidth="1.3"/> <span class="font-light">Permissions</span>
                    </div>

                    <div class="grid grid-cols-2 gap-[16px]">
                        <permissionBtn v-for="value in permissions" :key="value.id" :userId="id" :userPerm="userPermission" :permission="value" @child-action="actualisePermission"/>
                    </div>
                </div>

                <div class="w-full" v-if="getActiveTab('Zone autorisé')">
                    <div class="flex items-center gap-x-[12px] mb-[16px]">
                        <MapPinned :size="18" strokeWidth="1.3"/> <span class="font-light">Zone autorisé</span>
                    </div>

                    <div class="grid grid-cols-2 gap-[16px]">
                        <autoriseZone v-for="value in zone" :key="value.id" :userId="id" :zone="value" @child-action="getZones"/>
                    </div>
                </div>

                <div class="w-full" v-if="getActiveTab('Exit')">
                    <div class="flex items-center gap-x-[12px] mb-[16px]">
                        <LogOut :size="18" strokeWidth="1.3"/> <span class="font-light">Formulaire exit</span>
                    </div>

                    <div class="w-full flex items-center justify-between">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="date" class="font-light">Date de fin</label>
                            <input type="date" v-model="update_contrat.exit_date" name="date" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="motif" class="font-light">Motif de départ<span class="text-[#f44545]">*</span></label>
                            <select v-model="update_contrat.exit_motive" name="shift" id="shift" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                <option value="">Selectionner le motif</option>
                            </select>
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex items-center justify-between ">
                            <label for="device" class="font-light">Equipement à déposer<span class="text-[#f44545]">*</span></label>
                            <input type="checkbox" v-model="update_contrat.devices" name="device" class="size-[16px] rounded-md border static opacity-100" id="device">
                            <!-- <textarea name="detail" id="detail" class="h-[180px] w-full rounded-xl border outline-none p-3 focus:outline-none"></textarea> -->
                        </div>
                    </div>

                    <div class="w-[49%] mt-[8px]">
                        <button v-on:click="updateContrat" :disabled="asSend" class="h-[35px] font-light w-full bg-[#5357ec] text-white rounded-xl flex items-center justify-center">
                            <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                            <span v-if="!asSend">Soumettre</span>
                        </button>
                    </div>
                </div>

                <div class="w-full" v-if="getActiveTab('Validateur')">
                    <div class="flex items-center gap-x-[12px] mb-[16px]">
                        <UserPen :size="18" strokeWidth="1.3"/> <span class="font-light">Ajouter un validateur</span>
                    </div>

                    <div class="w-full flex items-center justify-between">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="validateur" class="font-light">Validateur<span class="text-[#f44545]">*</span></label>
                            <select v-model="validation.validator_id" name="validateur" id="validateur" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                <option value="">Selectionner le validateur</option>
                                <option v-for="value in users" :key="value.id" :value="value.id">{{ value.first_name + " " + value.last_name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-between mt-[8px]">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="level" class="font-light">Niveau de validation</label>
                            <input type="number" max="3" min="1" v-model="validation.level" name="level" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                        </div>
                    </div>

                    <div class="w-[49%] mt-[8px]">
                        <button v-on:click="addUserValidator" :disabled="loader" class="h-[35px] font-light w-full bg-[#5357ec] text-white rounded-xl flex items-center justify-center">
                            <Loader2 v-if="loader" class="animate-spin mx-auto"/>
                            <span v-if="!loader">Enregistrer</span>
                        </button>
                    </div>

                    <div class="w-full my-[16px] h-[1px]"></div>
                    <h2 class="font-light underline">Liste des validateurs</h2>

                    <div class="mt-[16px] grid grid-cols-2 gap-[16px]">
                        <ValidatorCard v-for="value in list_validator" :key="value.id" :item="value"  @child-action="getAllValidator"/>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="animate-pulse">
                <div class="h-[40px] w-[180px] mb-[8px] rounded-xl bg-gray-100"/>
                <div class="h-[40px] w-[220px] mb-[16px] rounded-xl bg-gray-100"/>
                <div class="h-[190px] w-full mb-[16px] rounded-xl bg-gray-100"></div>
                <div class="flex items-center mb-[16px] gap-x-[12px]">
                    <div class="h-[40px] w-[140px] mb-[8px] rounded-xl bg-gray-100"/>
                    <div class="h-[40px] w-[140px] mb-[8px] rounded-xl bg-gray-100"/>
                    <div class="h-[40px] w-[140px] mb-[8px] rounded-xl bg-gray-100"/>
                    <div class="h-[40px] w-[140px] mb-[8px] rounded-xl bg-gray-100"/>
                    <div class="h-[40px] w-[140px] mb-[8px] rounded-xl bg-gray-100"/>
                </div>
                <div class="h-[250px] w-full mb-[16px] rounded-xl bg-gray-100"></div>
            </div>
        </template>
    </div>
</template>
<script>
import toast from "@/components/ui/toast/index.js";
import API from "../../service/API.js";
import contractStory from "@/components/btn/contract-story.vue";
import {Loader2,HandCoins,UserPen,MapPinned,LogOut,AtSign,DoorOpen,GitPullRequest,Phone,ArrowLeft,SquareUserRound,CreditCard,FilePenLine,FileUser,ChartNoAxesGantt,FolderLock} from "lucide-vue-next";
import Swal from 'sweetalert2'
import permissionBtn from "@/components/btn/permission-btn.vue";
import autoriseZone from "@/components/btn/autorise-zone.vue";
import ValidatorCard from "@/components/btn/validator-card.vue";
import DocumentColab from "@/components/document-colab.vue";
import ExperienceColab from "@/components/experience-colab.vue";
import { convertirDateEnFrancais } from "@/utils/date-format.js";
export default {
    name: "ColabDetails",
    components: {
        Loader2,HandCoins,ExperienceColab,ValidatorCard,DocumentColab,UserPen,AtSign,LogOut,MapPinned,ArrowLeft,GitPullRequest,autoriseZone,DoorOpen,Phone,contractStory,SquareUserRound,CreditCard,FilePenLine,FileUser,ChartNoAxesGantt,FolderLock,permissionBtn
    },
    data(){
        return {
            id: '',
            load: true,
            asSend: false,
            asSend2: false,
            asSend3: false,
            isExiting:false,
            user:{},
            loader:false,
            validation:{},
            list_validator:[],
            shifts:[],
            profils:[],
            contrats:[],
            permissions:[],
            zone:[],
            userPermission:[],
            update_contrat:{},
            advances:[],
            active: "Personnel",
            users:[],
            form: {
            },
            profildata:{
                profile_id:null,
                start:null,
                end:null,
                salary:null,
                contract_type:null,
                job_name:null,
                sursalaire:null,
                prime_tp:null,
                prime_respo:null,
                prime_speciale:null,
                prime_logement:null,
                employee_status:null,
            }
        }
    },
    mounted(){
        this.isExiting = this.$route.query.exit;
        if(this.$route.query.exit) this.active = "Historique des contrats";
        this.getUsersInfo(this.id);
        this.getData();
        this.getAllProfil();
        this.getAllPermission();
        this.getAllUserPermission();
        this.getZones();
        this.getUsers();
        this.getAllValidator();
    },
    created(){
        this.id = this.$route.params.userId;
    },
    methods: {
        formatDate(date){return convertirDateEnFrancais(date)},
        getAllProfil(){
            API.get("getAllProfiles")
            .then((res)=>{
                    if(!res.data.status) throw new Error(res.data.message);
                    this.profils = res.data.data;
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
        },
        getActiveClass(libelle){
            return `px-4 py-3 rounded-xl font-extralight cursor-pointer ${libelle == this.active ? "bg-[#5357eb] text-white" : "bg-[#f9fafb] text-black"}`;
        },
        selectBar(libelle){
            this.active = libelle;
        },
        getActiveTab(libelle){
            return this.active == libelle
        },
        getData() {
            API.get('shifts')
                .then((res) => {
                    if(!res.data.status) throw new Error(res.data.message);
                    this.shifts = res.data.data
                })
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
        },
        getUsersInfo(id){
            API.get('fetchUser/'+id)
            .then((response)=>{
                if(!response.data.status) throw new Error(response.data.message);
                    const {first_name,is_hr,last_name,email,birthdate,serial,matricule,shift,children_nb,rib,swift,bank,n_cnps} = response.data.user;
                    this.form = {first_name,is_hr,last_name,email,birthdate,serial,matricule,shift,children_nb,rib,swift,bank,n_cnps}
                    this.contrats = response.data.user.profile;
                    this.advances = [...response.data.user.advances];
                    this.contrat_id = response.data.user.contrat?.id;
                    this.update_contrat = {...response.data.user.contract}
                    this.user = {...response.data.user,exceptions: response.data.exceptions,requests: response.data.requests};
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{this.load = false});
        },
        updateEmploye(){
            this.asSend = true;
            API.post('updateEmployee/' + this.id,{...this.form})
            .then((res)=>{
                if(res.data.status){
                  this.getUsersInfo(this.id);
                  Swal.fire('Succès!!!!',"Infomation mis à jour",'succes')
                }
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{this.asSend = false;})
        },
        addNewContrat(){
            this.asSend2 = true;
            API.post("/user_profiles",{...this.profildata,user_id:this.id,status:"ACTIVE"})
            .then((res)=>{
                if(!res.data.status)  throw Error(res.data.message);
                toast.success("Succès","Infomation mis à jour",5000);
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.asSend2 = false;
            })
        },
        pushback(){
            this.$router.go(-1);
        },
        updateContrat(){
            this.asSend3 = true;
            API.put('user_profiles/' + this.update_contrat.id,this.update_contrat)
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message);
                this.getUsersInfo(this.id);
                Swal.fire('Succès',"Infomation mis à jour",'succes');
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.asSend3 = false
            })
        },
        getAllPermission(){
            API.get("permissions")
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message)
                this.permissions = res.data.data;
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'));
        },
        getAllUserPermission(){
            API.get("permissions/user/"+this.id)
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message);
                this.userPermission = res.data.data;
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'));
        },
        actualisePermission(){
            this.getAllPermission();
            this.getAllUserPermission();
        },
        getZones(){
            API.get("getAllZones")
            .then(res=>{
                if(res.status != 200) throw Error(res.data.message);
                this.zone = res.data.data;
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
        },
        getUsers() {
            API.get('/getAllEmployees')
                .then((res) => {
                    if(!res.data.status) throw Error(res.data.message);
                    this.users = res.data.data.filter((el)=> el.id != this.id);
                })
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
        },
        addUserValidator(){
            this.loader = true;
            const data = {
                validator_id: this.validation.validator_id,
                employee_id: this.id,
                level: this.validation.level
            }
            API.post("/validators",data)
            .then((response)=>{
                if(!response.data.status) throw Error(response.data.message);
                this.validation={}
                this.getAllValidator();
                Swal.fire({title: 'Succès !',text: 'Validateur enregistré',icon: 'success',})
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{this.loader = false})
        },
        getAllValidator(){
            API.get("/validators")
            .then(response=>{
                if(!response.data.status) throw Error(response.data.message);
                this.list_validator = response.data.data.filter(el=>el.employee_id == this.id)
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
        }
    }
}
</script>